import React from 'react';
import './App.css';
import VideoBackground from './VideoBackground';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTiktok, faSpotify, faApple, faSoundcloud } from '@fortawesome/free-brands-svg-icons';

function App() {

  return (
    <div className="App">
      <VideoBackground />

    <div className="content-section container">
      <h1>Bio</h1>
      <hr />
      <div className="bio-content">
        <img
          src="/profile.jpg"
          alt="Emily Motyka"
          className="bio-photo"
        />
        <div className="bio-text">
          <p>emily motyka is a multi-disciplined artist from New York. She holds upstate NY and the Adirondack mountains dear to her heart, but has called Brooklyn home since 2019.</p>
          <p>Trained in fine arts and oil painting, Emily has also been a vocalist since birth and a self taught music producer in recent years.</p>
          <p>She is inspired by a range of sounds but notable genres are alternative rock, experimental electronic, indie music of the 2010s and classic American folk. Radiohead, Beach House and Adrienne Lenker are her idols.</p>
        </div>
      </div>
    </div>


      <div id="music-section" className="content-section container">
        <h1>Music</h1>
        <hr />
        <div className="track-list">
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/2QSy1VUoh0fwsM7e25O5zJ?utm_source=generator"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 1"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/4AIV6Hm0Y5VOtEWX5zCn6W?utm_source=generator"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 2"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/1oPW0Ih0y2H1W01dE9Rzjw?utm_source=generator"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 3"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/4MVhRGZKNE3arodfxkSubo?utm_source=generator"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 4"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/3rcppcSqOefn9EvrbFw1Kn?utm_source=generator"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 5"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/2saYlobCjd136iOx4T9po6?utm_source=generator"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 6"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/0FFriwp0fUZdOkHjra33SV?utm_source=generator"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 7"
          ></iframe>
        </div>
      </div>



      <div className="social-media-links container">
        <a href="https://www.instagram.com/em_motyka/" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} size="2x" />
        </a>
        <a href="https://www.tiktok.com/@em_motyka" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faTiktok} size="2x" />
        </a>
        <a href="https://open.spotify.com/artist/7LsZ8YYbafN4kjSnzRv7F5" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faSpotify} size="2x" />
        </a>
        <a href="https://music.apple.com/us/artist/emily-motyka/1682800252" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faApple} size="2x" />
        </a>
        <a href="https://on.soundcloud.com/GFaPslxzuVJzGgOKwm" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faSoundcloud} size="2x" />
        </a>
      </div>
    </div>
  );
}

export default App;
